/* alterado em 17/03/2026 por CG — MOQ sem bloquear checkout no carrinho/drawer */
(function () {
  const MOQ = 20;

  /* ---------- Utils ---------- */
  async function fetchCart() {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return { item_count: 0, items: [] };
      return await response.json();
    } catch (_) {
      return { item_count: 0, items: [] };
    }
  }

  function ensureNotice(container, id, html) {
    if (!container) return null;

    let el = container.querySelector(`#${id}`);
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.className = 'ventura-moq-notice';
      container.prepend(el);
    }

    el.innerHTML = html;
    return el;
  }

  function addOnceStyles() {
    if (document.getElementById('ventura-moq-styles')) return;

    const css = `
      .ventura-moq-notice{padding:12px 14px;margin:10px 0 16px;border:1px solid rgb(0 0 0 / .15);font-size:.98rem;line-height:1.45}
      .ventura-moq-warning{color:#7c2d12}
      .ventura-moq-ok{color:#1a7f37}
      .product-form__buttons .ventura-moq-pdp.is-warning{border-color:#b54708;background:#fff7ed;color:#7c2d12}
      @keyframes ventura-shake{10%,90%{transform:translateX(-1px)}20%,80%{transform:translateX(2px)}30%,50%,70%{transform:translateX(-3px)}40%,60%{transform:translateX(3px)}}
      .ventura-shake{animation:ventura-shake .45s ease}
    `;

    const style = document.createElement('style');
    style.id = 'ventura-moq-styles';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  /* ---------- Cart / Drawer (somente aviso; sem bloquear checkout) ---------- */
  function formatCartMsgPerItem(items) {
    const bad = items.filter((item) => item.quantity < MOQ);

    if (bad.length === 0) {
      return `
        <div class="ventura-moq-ok">
          ✅ All models meet the minimum (${MOQ} units each).
        </div>
        <div class="ventura-moq-leadtime">
          Lead time: <strong>70 days</strong> after payment confirmation.
        </div>
      `;
    }

    const list = bad
      .map((item) => {
        const need = MOQ - item.quantity;
        const title = item.product_title || item.title || 'Item';
        return `• <strong>${title}</strong>: ${item.quantity} / ${MOQ} (add ${need} more)`;
      })
      .join('<br>');

    return `
      <div class="ventura-moq-warning">
        <strong>Minimum per model:</strong> ${MOQ} units each.<br>
        The following items are below the minimum:<br>${list}
      </div>
      <div class="ventura-moq-leadtime">
        Lead time: <strong>70 days</strong> after payment confirmation.
      </div>
    `;
  }

  async function renderCartNotice(container, bannerId) {
    const cart = await fetchCart();
    const msg = formatCartMsgPerItem(cart.items || []);
    ensureNotice(container, bannerId, msg);
  }

  function applyOnCartPage() {
    const cartForm = document.querySelector('form[action="/cart"]');
    if (!cartForm) return;

    const container = cartForm.closest('cart-items, .cart__items, main') || cartForm;
    renderCartNotice(container, 'ventura-moq-banner');

    cartForm.addEventListener(
      'change',
      () => {
        window.setTimeout(() => {
          renderCartNotice(container, 'ventura-moq-banner');
        }, 250);
      },
      true
    );
  }

  function applyOnCartDrawer() {
    const drawer =
      document.querySelector('cart-drawer, #CartDrawer') || document.querySelector('cart-drawer');

    if (!drawer) return;

    const render = () => {
      const container =
        drawer.querySelector('.cart-drawer__footer, footer, form[action="/cart"]') || drawer;
      renderCartNotice(container, 'ventura-moq-banner-drawer');
    };

    new MutationObserver(() => {
      render();
    }).observe(drawer, { childList: true, subtree: true });

    render();
  }

  /* ---------- PDP (mínimo por modelo) ---------- */
  function pdpQtyInput() {
    return (
      document.querySelector('.ventura-qty__input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]')
    );
  }

  function pdpBannerEl() {
    return document.querySelector('#ventura-moq-pdp');
  }

  function addBtnEl() {
    return document.querySelector(
      '.product-form__buttons .product-form__submit,[name="add"].product-form__submit'
    );
  }

  function currentQty() {
    const el = pdpQtyInput();
    return Math.max(1, parseInt((el && el.value) || '1', 10) || 1);
  }

  function formatPdpMsgPerItem(qty) {
    if (qty < MOQ) {
      return `
        <strong>Minimum per model:</strong> ${MOQ} units.<br>
        This product: ${qty}. You need <strong>${MOQ - qty}</strong> more to add.<br>
        <span class="ventura-moq-leadtime">
          Lead time: <strong>70 days</strong> after payment confirmation.
        </span>
      `;
    }

    return `
      ✅ This product meets the minimum: <strong>${qty}</strong> units.<br>
      <span class="ventura-moq-leadtime">
        Lead time: <strong>70 days</strong> after payment confirmation.
      </span>
    `;
  }

  function applyOnPDP() {
    addOnceStyles();

    const qty = pdpQtyInput();
    const banner = pdpBannerEl();
    const btn = addBtnEl();
    const form =
      document.querySelector('product-form form[id^="product-form-"]') ||
      document.querySelector('form[id^="product-form-"]');

    if (!qty || !banner || !btn || !form) return;

    const render = () => {
      banner.innerHTML = formatPdpMsgPerItem(currentQty());
    };

    render();

    document.querySelectorAll('[data-qty-minus]').forEach((button) =>
      button.addEventListener('click', () => {
        qty.value = Math.max(1, currentQty() - 1);
        render();
      })
    );

    document.querySelectorAll('[data-qty-plus]').forEach((button) =>
      button.addEventListener('click', () => {
        qty.value = currentQty() + 1;
        render();
      })
    );

    qty.addEventListener('input', render);

    function blockIfNeeded(event) {
      if (currentQty() < MOQ) {
        event.preventDefault();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        event.stopPropagation();

        banner.classList.add('is-warning');
        banner.innerHTML = formatPdpMsgPerItem(currentQty());

        btn.classList.remove('ventura-shake');
        void btn.offsetWidth;
        btn.classList.add('ventura-shake');

        btn.disabled = true;
        setTimeout(() => {
          btn.disabled = false;
        }, 800);

        banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        banner.classList.remove('is-warning');
      }
    }

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target.closest(
          '.product-form__submit,[name="add"].product-form__submit'
        );
        if (!target || target !== btn) return;
        blockIfNeeded(event);
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const targetForm = event.target;
        const isProductForm =
          targetForm && targetForm.closest('product-form, form[id^="product-form-"]');
        if (!isProductForm) return;
        blockIfNeeded(event);
      },
      true
    );

    const productForm = document.querySelector('product-form');
    if (productForm) {
      productForm.addEventListener('submit', blockIfNeeded, { capture: true });
    }
  }

  /* ---------- Init ---------- */
  function init() {
    applyOnCartPage();
    applyOnCartDrawer();
    applyOnPDP();
  }

  document.addEventListener('DOMContentLoaded', init);
})();